import { formatar, textos } from './config';
import { apagarBuscaRecente, buscasRecentes, localDaConexao } from './local';
import { avisarSucesso } from './aviso';
import { ocupado, ocupar } from './botao';
import { desempilhar, empilhar, travarFundo } from './sobreposicao';

// Busca em tela cheia do celular (openSov/closeSov da v36), da home e da busca: a página diz o que vai nos campos
// e o que fazer ao buscar e ao usar a localização.
const $ = id => document.getElementById(id);
let _opcoes = { valores: () => ({ q: '', l: '' }), aoBuscar: () => {}, aoUsarLocalizacao: () => {} };

export const textosBusca = textos($('sovForm'));

export function icone(nome) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'ico ');
    svg.setAttribute('aria-hidden', 'true');
    const use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
    use.setAttribute('href', `#i-${nome}`);
    svg.append(use);
    return svg;
}

function _sugestao(nomeIcone, principal, sub, dados) {
    const linha = document.createElement('div');
    linha.className = 'sugg-row';
    const b = document.createElement('button');
    b.className = 'sugg';
    b.type = 'button';
    Object.entries(dados).forEach(([k, v]) => { b.dataset[k] = v; });
    const s = document.createElement('span');
    s.append(principal);
    if (sub) {
        const small = document.createElement('small');
        small.textContent = sub;
        s.append(small);
    }
    b.append(icone(nomeIcone), s);
    linha.append(b);
    return linha;
}

function _desenharListas() {
    const t = textosBusca;
    const conexao = localDaConexao();
    const caixaConexao = $('sovConexao');
    if (caixaConexao) {
        caixaConexao.replaceChildren();
        caixaConexao.hidden = !conexao;
        if (conexao) {
            caixaConexao.replaceWith(Object.assign(_sugestao('geo-alt-fill', conexao.nome, t.conexaoSugg, { loc: conexao.nome }), { id: 'sovConexao' }));
        }
    }
    const recentes = buscasRecentes();
    const caixa = $('sovRecent');
    if (!caixa) {
        return;
    }
    if (!recentes.length) {
        const p = document.createElement('p');
        p.className = 'fnote';
        p.textContent = t.nenhumaRecente;
        caixa.replaceChildren(p);
        return;
    }
    caixa.replaceChildren(...recentes.map(([q, l], i) => {
        // O loc vai mesmo vazio: a busca recente sem local também limpa o "Onde" (como no campoBusca); o "Mais buscados" o mantém.
        const linha = _sugestao('clock-history', q, l, { q, loc: l || '' });
        const apagar = document.createElement('button');
        apagar.className = 'icon-btn icon-btn--flat';
        apagar.type = 'button';
        apagar.dataset.rmrec = String(i);
        apagar.setAttribute('aria-label', formatar(t.apagarBusca, q));
        apagar.append(icone('x-lg'));
        linha.append(apagar);
        return linha;
    }));
}

// Quem abriu (a pílula ou o "Buscar" da barra) recebe o foco de volta ao fechar. Só esses: o campo da home que abre a busca no
// celular perde o foco antes, e devolvê-lo abriria de novo. O Safari não dá foco a botão no toque: vale o último tocado.
const _GATILHOS = '[data-sov], .bnav [data-bn="busca"]';
let _abriuPor = null;
let _ultimoToque = null;
document.addEventListener('click', e => {
    _ultimoToque = e.target.closest?.(_GATILHOS) || null;
}, true);

export function abrirSov(foco = 'Q', abridor = null) {
    const sov = $('sov');
    if (!sov || sov.classList.contains('is-open')) {
        return;
    }
    _abriuPor = abridor || document.activeElement?.closest?.(_GATILHOS) || _ultimoToque;
    _ultimoToque = null;
    empilhar('v2Sov', () => fecharSov({ peloHistorico: true }));
    const { q, l } = _opcoes.valores();
    $('sovQ').value = q || '';
    $('sovL').value = l || '';
    _desenharListas();
    sov.classList.add('is-open');
    travarFundo(true);
    // No hotsite o campo pedido pode estar escondido (FiltrosVisiveis): o foco vai para o que está na tela.
    const alvo = [foco === 'L' ? $('sovL') : $('sovQ'), $('sovL'), $('sovQ')].find(c => c && !c.closest('[hidden]')) || $('sovClose');
    setTimeout(() => alvo?.focus(), 60);
}

export function fecharSov({ peloHistorico = false } = {}) {
    const sov = $('sov');
    if (!sov?.classList.contains('is-open')) {
        return;
    }
    sov.classList.remove('is-open');
    travarFundo(false);
    if (!peloHistorico) {
        desempilhar('v2Sov');
    }
    _abriuPor?.focus({ preventScroll: true });
    _abriuPor = null;
}

export function iniciarBuscaTelaCheia(opcoes) {
    _opcoes = { ..._opcoes, ...opcoes };
    if (!$('sov')) {
        return;
    }

    document.addEventListener('click', e => {
        const alvo = e.target;
        if (alvo.closest('#sovClose')) {
            fecharSov();
            return;
        }
        const limpar = alvo.closest('#sov [data-clr]');
        if (limpar) {
            e.preventDefault();
            const campo = $(limpar.dataset.clr);
            campo.value = '';
            campo.focus();
            return;
        }
        const apagar = alvo.closest('#sov [data-rmrec]');
        if (apagar) {
            apagarBuscaRecente(+apagar.dataset.rmrec);
            _desenharListas();
            avisarSucesso(textosBusca.buscaApagada);
            return;
        }
        if (alvo.closest('#sov [data-geo]')) {
            _opcoes.aoUsarLocalizacao();
            return;
        }
        const sugestao = alvo.closest('#sov .sugg');
        if (sugestao) {
            // Campo escondido no hotsite (FiltrosVisiveis) não recebe: a busca sairia com um filtro que a pessoa não vê.
            if ('loc' in sugestao.dataset && !$('sovL').closest('[hidden]')) {
                $('sovL').value = sugestao.dataset.loc;
            }
            if (sugestao.dataset.q && !$('sovQ').closest('[hidden]')) {
                $('sovQ').value = sugestao.dataset.q;
            }
            // Tocar na sugestão já busca (dono, 04/11/2026: só preencher parecia não fazer nada). Pelo botão, para o submit e a roda
            // serem os mesmos do "Buscar vagas".
            $('sovForm')?.querySelector('[type="submit"]')?.click();
        }
    });

    $('sovForm')?.addEventListener('submit', e => {
        e.preventDefault();
        // Todo aoBuscar troca de página: a roda fica até lá (o botao.js a tira na volta pelo cache do navegador).
        const botao = e.currentTarget.querySelector('[type="submit"]');
        if (ocupado(botao)) {
            return;
        }
        ocupar(botao);
        _opcoes.aoBuscar($('sovQ').value, $('sovL').value);
    });

    document.addEventListener('keydown', e => {
        // Com a janela de cookies ou de sessão aberta, o Esc é dela.
        if (e.key === 'Escape' && $('sov')?.classList.contains('is-open') && !document.querySelector('dialog[open]')) {
            fecharSov();
        }
    });
}
